import React from 'react';
import PropTypes from 'prop-types';

import Label from '../../../../../../components/Label';

const HoursInput = (props) => {
  const { hourType, title, errors, values, onChange } = props;
  const openingHour = `${hourType}OpeningHour`;
  const closingHour = `${hourType}ClosingHour`;

  return (
    <div className="input">
      <Label name="normalHours" title={title} errors={errors} />
      <div className="hours-input">
        <input
          type="number"
          id={openingHour}
          value={values[openingHour]}
          onChange={onChange}
          min="0"
          max="24"
        />
        <span>:00 to</span>
        <input
          type="number"
          id={closingHour}
          value={values[closingHour]}
          onChange={onChange}
          min="0"
          max="24"
        />
        <span>:00</span>
      </div>
    </div>
  );
};

export default HoursInput;

HoursInput.propTypes = {
  hourType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  errors: PropTypes.shape(),
  values: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
};

HoursInput.defaultProps = {
  errors: {},
};
